import { FC, useState } from 'react'
import './ToolbarDownload.scss'
import { ToolbarDownloadButton } from './ToolbarDownloadButton'
import { ToolbarDownloadPopup } from './ToolbarDownloadPopup'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { CutterActionType } from '../enums/CutterActionType'

export const ToolbarDownload: FC = () => {
  const [popupOpened, setPopupOpened] = useState(false)

  return (
    <div className="ToolbarDownload">
      <ToolbarDownloadButton
        onClick={() => {
          logger.log(LogActionType.ToolbarButtonClick, { type: CutterActionType.Download })

          setPopupOpened(true)
        }}
      />

      {popupOpened && <ToolbarDownloadPopup close={() => setPopupOpened(false)} />}
    </div>
  )
}
